export interface BarChartData {
  labels: string[];
  data: number[];
}

const EDAD_LABELS = [
  'Niños (0-11)',
  'Adolescentes (12-17)',
  'Jóvenes (18-35)',
  'Adultos (36-64)',
  'Mayores (65+)',
];

export function buildEdadesBar(counts: number[]): BarChartData {
  return {
    labels: EDAD_LABELS,
    data: EDAD_LABELS.map((_, index) => counts[index] ?? 0),
  };
}

export function buildNivelesBar(counts: number[], setLevel: number): BarChartData {
  const total = setLevel === 3 ? 6 : 5;
  return {
    labels: Array.from({ length: total }, (_, index) => `Nv. ${index}`),
    data: Array.from({ length: total }, (_, index) => counts[index] ?? 0),
  };
}
